import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="py-8 px-4 border-t border-gray-200 dark:border-gray-800">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row justify-between items-center gap-4 text-sm text-gray-500">
        <div className="flex items-center gap-2">
          <div className="w-6 h-6 rounded-md bg-gradient-to-br from-brand-500 to-accent-500 flex items-center justify-center text-white font-bold text-[10px]">
            K2
          </div>
          <span>Kuadra2 &copy; {new Date().getFullYear()}</span>
        </div>
        <div className="flex gap-6">
          <a href="#" className="hover:text-gray-900 dark:hover:text-gray-300 transition-colors">
            {t('landing.footer.privacy')}
          </a>
          <a href="#" className="hover:text-gray-900 dark:hover:text-gray-300 transition-colors">
            {t('landing.footer.terms')}
          </a>
          <a href="#" className="hover:text-gray-900 dark:hover:text-gray-300 transition-colors">
            {t('landing.footer.contact')}
          </a>
        </div>
      </div>
    </footer>
  );
}
